import { render } from "./LeaveApplicationModal.vue?vue&type=template&id=2f5b4806&scoped=true"
import script from "./LeaveApplicationModal.vue?vue&type=script&lang=js"
export * from "./LeaveApplicationModal.vue?vue&type=script&lang=js"

import "./LeaveApplicationModal.vue?vue&type=style&index=0&id=2f5b4806&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5b4806"]])

export default __exports__